<template>
  <v-app>
    <v-navigation-drawer
      v-if="logado"
      :clipped="$vuetify.breakpoint.lgAndUp"
      v-model="drawer"
      app
    >
      <menu-master v-if="user.tipo == 'master'"></menu-master>
      <menu-cliente
        v-if="user.tipo == 'cliente'"
        :notificacoes="notificacoes"
      ></menu-cliente>
      <menu-administrador
        v-if="user.tipo == 'administrador'"
      ></menu-administrador>
      <!-- <menu-representante v-if="user.tipo == 'representante'" :notificacoes="notificacoes"></menu-representante> -->
      <menu-representante
        v-if="user.tipo == 'representante'"
        :notificacoes="$store.state.count_notificacoes"
      ></menu-representante>
      <menu-fornecedor
        v-if="user.tipo == 'fornecedor'"
        :notificacoes="notificacoes"
      ></menu-fornecedor>
    </v-navigation-drawer>

    <v-app-bar
      src="img/appbar-background.jpg"
      :clipped-left="$vuetify.breakpoint.lgAndUp"
      app
      color="#ffd600"
      dark
      :prominent="!$vuetify.breakpoint.smAndDown"
      :height="$vuetify.breakpoint.smAndDown ? '64px' : '128px'"
      min-height="64px"
    >
      <template v-slot:img="{ props }">
        <v-img
          v-bind="props"
          :gradient="
            `to top right, ${hexToRgbA(
              $vuetify.theme.themes.light.accent,
              '1'
            )}, ${hexToRgbA($vuetify.theme.themes.light.accent, '0.75')}`
          "
        ></v-img>
      </template>

      <v-col
        cols="6"
        :class="!$vuetify.breakpoint.smAndDown ? 'pa-0 pt-2' : 'pa-0'"
      >
        <v-row
          dense
          class="pa-0 ma-0"
          :style="
            !logado && $vuetify.breakpoint.mdAndUp
              ? 'flex-flow: row; height: 110px'
              : 'flex-flow: row; height: 48px'
          "
        >
          <v-app-bar-nav-icon
            v-if="logado"
            @click.stop="drawer = !drawer"
            color="black"
            class="ml-0 my-auto hidden-md-and-up"
            :clipped-left="$vuetify.breakpoint.lgAndUp"
          />
          <img
            src="@/assets/logo.svg"
            class="mr-2"
            :style="
              !logado && $vuetify.breakpoint.mdAndUp
                ? 'max-height: 96px; cursor: pointer'
                : 'max-height: 48px; cursor: pointer'
            "
            @click="reloadPage"
          />
          <img
            src="@/assets/name.svg"
            class="ml-1 my-auto hidden-sm-and-down"
            :style="
              !logado && $vuetify.breakpoint.mdAndUp
                ? 'max-height: 72px; cursor: pointer'
                : 'max-height: 40px; cursor: pointer'
            "
            @click="reloadPage"
          />
          <v-text-field
            solo
            dense
            label="Pesquise aqui"
            class="mt-1 ml-2 hidden-xs-and-down"
            hide-details
            append-icon="mdi-magnify"
            v-if="
              $router.currentRoute.name === 'loja' &&
                $vuetify.breakpoint.smAndUp &&
                !$vuetify.breakpoint.mdAndUp
            "
            v-model="filtro.termoPesquisa"
            @click:append="pesquisarProdutosClick"
            @keydown.prevent.enter="pesquisarProdutos"
          />
          <v-toolbar-title
            v-if="logado && $router.currentRoute.name !== 'loja'"
            class="pl-4 pt-2 black--text hidden-md-and-up"
            style="overflow: hidden; text-overflow: ellipsis; white-space: pre"
          >
            <span>{{
              user.cliente_nome ||
                user.fornecedor_nome ||
                user.representante_nome ||
                user.administrador_nome ||
                user.master_nome
            }}</span>
          </v-toolbar-title>

          <v-btn
            fab
            dark
            small
            color="black"
            class="my-auto"
            v-if="
              ['loja', 'showroomRodada'].includes(
                this.$router.currentRoute.name
              ) && $vuetify.breakpoint.xsOnly
            "
            @click="$refs.pesquisaDialogo.abrir()"
          >
            <v-icon>mdi-magnify</v-icon>
          </v-btn>
        </v-row>

        <v-row
          dense
          v-if="logado"
          class="mt-2 hidden-sm-and-down black--text"
          style="flex-flow: row"
        >
          <v-app-bar-nav-icon
            @click.stop="drawer = !drawer"
            color="black"
            :clipped-left="$vuetify.breakpoint.lgAndUp"
          />
          <v-toolbar-title
            class="px-2"
            style="overflow: hidden; text-overflow: ellipsis; white-space: pre"
          >
            <span>{{
              user.cliente_nome ||
                user.fornecedor_nome ||
                user.representante_nome ||
                user.administrador_nome ||
                user.master_nome
            }}</span>
          </v-toolbar-title>
        </v-row>
      </v-col>

      <v-col
        cols="6"
        :class="!$vuetify.breakpoint.smAndDown ? 'pa-0 pt-2' : 'pa-0'"
      >
        <v-row
          dense
          class="ma-0"
          style="display: flex; justify-content: flex-end; align-items: center"
        >
          <div class="ml-2" style="display: flex; width: 100%; height: 40px">
            <v-text-field
              solo
              dense
              label="Pesquise aqui"
              class="ma-0 hidden-sm-and-down"
              hide-details
              full-width
              append-icon="mdi-magnify"
              v-if="
                ['loja', 'showroomRodada'].includes(
                  this.$router.currentRoute.name
                )
              "
              v-model="filtro.termoPesquisa"
              @click:append="pesquisarProdutosClick"
              @keydown.prevent.enter="pesquisarProdutos"
            />
            <v-spacer />
            <v-btn
              fab
              dark
              small
              class="ml-2 my-auto"
              v-if="
                (!logado ||
                  user.tipo === 'cliente' ||
                  user.tipo === 'representante' ||
                  (user.tipo === 'fornecedor' &&
                    $store.state.rodadaSetada &&
                    $store.state.rodada.permitir_pedidos)) &&
                  $router.currentRoute.name !== 'checkout'
              "
              @click="drawerShop = !drawerShop"
            >
              <v-badge
                bordered
                color="error"
                :content="$store.state.produtos.length"
                :value="$store.state.produtos.length"
                overlap
              >
                <v-icon>mdi-cart</v-icon>
              </v-badge>
            </v-btn>

            <v-menu dense top offset-y v-if="logado">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  color="primary darken-2"
                  text-color="white"
                  class="ml-2 px-2 hidden-xs-only"
                  style="min-width: 98px; height: auto"
                  v-bind="attrs"
                  v-on="on"
                  @click="checkIlhaImpressao"
                >
                  <v-avatar left size="28" class="mr-2">
                    <img :src="user_avatar" />
                  </v-avatar>
                  <div
                    style="max-width: 100px; overflow: hidden; text-overflow: ellipsis; white-space: pre; max-width: 64px"
                  >
                    {{ user.nome }}
                  </div>
                </v-btn>
              </template>

              <v-list dense>
                <v-list-item
                  dark
                  :style="
                    'background-color:' + $vuetify.theme.themes.light.primary
                  "
                >
                  <v-list-item-title>
                    <span>{{ user.nome }}</span>
                    <v-list-item-subtitle>{{
                      user.tipo | capitalize
                    }}</v-list-item-subtitle>
                  </v-list-item-title>
                </v-list-item>

                <v-list-item @click="minhaConta" v-if="user.tipo !== 'master'">
                  <v-list-item-title>Minha Conta</v-list-item-title>
                </v-list-item>

                <v-list-item
                  @click="alterarLogo"
                  v-if="user.tipo == 'fornecedor'"
                >
                  <v-list-item-title>Alterar Logo</v-list-item-title>
                </v-list-item>

                <v-list-item @click="alterarSenha">
                  <v-list-item-title>Alterar Senha</v-list-item-title>
                </v-list-item>

                <v-list-item
                  v-show="mostrarIlhaDeImpressao"
                  v-if="user.tipo !== 'master'"
                >
                  <v-list-item-title>Ilha de Impressão</v-list-item-title>
                  <v-list-item-icon class="ma-0 pa-0 pt-1">
                    <v-switch
                      v-model="impressao_remota"
                      label
                      color="primary"
                      class="ma-0"
                    />
                  </v-list-item-icon>
                </v-list-item>

                <v-divider></v-divider>
                <v-list-item @click="logout">
                  <v-list-item-title>Sair</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>

            <v-btn
              color="black"
              text-color="white"
              class="ml-2 px-2 hidden-xs-only"
              @click="login"
              style="min-width: 98px; height: auto"
              v-else
            >
              <v-avatar left size="28" class="mr-1">
                <v-icon>mdi-account-circle</v-icon> </v-avatar
              >Entrar
            </v-btn>

            <v-menu dense top offset-y v-if="logado">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  fab
                  small
                  class="ml-2 my-auto hidden-sm-and-up"
                  v-bind="attrs"
                  v-on="on"
                  @click="checkIlhaImpressao"
                >
                  <img :src="user_avatar" width="40px" />
                </v-btn>
              </template>

              <v-list dense>
                <v-list-item
                  dark
                  :style="
                    'background-color:' + $vuetify.theme.themes.light.primary
                  "
                >
                  <v-list-item-title>
                    <span>{{ user.nome }}</span>
                    <v-list-item-subtitle>{{
                      user.tipo | capitalize
                    }}</v-list-item-subtitle>
                  </v-list-item-title>
                </v-list-item>

                <v-list-item @click="minhaConta">
                  <v-list-item-title>Minha Conta</v-list-item-title>
                </v-list-item>
                <!-- <v-list-item @click="alterarLogo" v-if="user.tipo == 'fornecedor'">
                  <v-list-item-title>Alterar Logo</v-list-item-title>
                </v-list-item> -->
                <v-list-item @click="alterarSenha">
                  <v-list-item-title>Alterar Senha</v-list-item-title>
                </v-list-item>

                <v-list-item v-show="mostrarIlhaDeImpressao">
                  <v-list-item-action>
                    <v-switch
                      v-model="impressao_remota"
                      label
                      color="primary"
                    ></v-switch>
                  </v-list-item-action>
                  <v-list-item-title>Ilha de Impressão</v-list-item-title>
                </v-list-item>

                <v-divider></v-divider>
                <v-list-item @click="logout">
                  <v-list-item-title>Sair</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>

            <v-btn
              v-else
              fab
              small
              class="my-auto ml-2 hidden-sm-and-up"
              @click="login"
            >
              <v-icon>mdi-account-circle</v-icon>
            </v-btn>

            <v-btn
              v-if="
                ['loja', 'showroomRodada'].includes(
                  this.$router.currentRoute.name
                )
              "
              fab
              small
              class="ml-2 my-auto hidden-md-and-up"
              @click="abrirFiltro"
            >
              <v-badge
                bordered
                color="accent"
                content="!"
                :value="
                  $store.state.filtro.categorias.length > 0 ||
                    $store.state.filtro.filtrarValores
                "
                overlap
              >
                <v-icon>mdi-tune</v-icon>
              </v-badge>
            </v-btn>
          </div>
        </v-row>
        <div
          v-show="
            ['loja', 'showroomRodada'].includes(this.$router.currentRoute.name)
          "
          class="mt-3 pa-2 pr-0 hidden-sm-and-down"
          style="height: 68px; width: 100%; display: flex"
          v-clickaway="fecharPainel"
        >
          <v-expansion-panels
            light
            style="min-height: 40px !important; height: 40px"
            v-model="expansionPanel"
          >
            <v-expansion-panel flat style="min-height: 40px !important">
              <v-expansion-panel-header
                class="pa-2"
                color="primary"
                style="min-height: 40px !important; color: white; border-radius: 4px"
              >
                <div>
                  <v-icon class="mr-2" color="white">mdi-tune</v-icon>
                  <span>Filtro</span>
                  <v-chip
                    v-if="categorias.length > 0"
                    class="ml-3"
                    color="white"
                    label
                    text-color="primary"
                    small
                    style="cursor: pointer"
                  >
                    <v-icon small left>{{
                      categorias.length === 1 ? "mdi-check" : "mdi-check-all"
                    }}</v-icon>
                    {{ categorias.length }} Categoria{{
                      categorias.length > 1 ? "s" : ""
                    }}
                    Selecionada{{ categorias.length > 1 ? "s" : "" }}
                  </v-chip>
                  <v-chip
                    v-if="filtrarValores"
                    class="ml-3"
                    color="white"
                    label
                    text-color="primary"
                    small
                    style="cursor: pointer"
                  >
                    <v-icon small class="mr-2">mdi-currency-brl</v-icon>
                    {{ valorInicial | valorBR }}
                    <v-icon small class="mx-2">mdi-arrow-left-right</v-icon>
                    {{ valorFinal | valorBR }}
                  </v-chip>
                  <v-chip
                    v-if="fornecedor && fornecedor.nome_fantasia"
                    class="ml-3"
                    color="white"
                    label
                    text-color="primary"
                    small
                    style="cursor: pointer"
                    >{{ fornecedor && fornecedor.nome_fantasia }}</v-chip
                  >
                  <!-- <v-chip
                    v-if="ordenacao"
                    class="ml-3"
                    color="white"
                    label
                    text-color="primary"
                    small
                    style="cursor: pointer"
                  >
                    <v-icon small left>mdi-sort-ascending</v-icon>
                    {{ordenacaoNome}}
                  </v-chip>-->
                </div>
                <template v-slot:actions>
                  <v-icon color="white">mdi-chevron-down</v-icon>
                </template>
              </v-expansion-panel-header>
              <v-expansion-panel-content class="wrapContent">
                <v-divider />
                <div
                  style="font-size: 18px; width: 100%; display: block; padding-top: 4px"
                >
                  Categorias
                </div>
                <div class="caption">Selecione uma ou mais categorias</div>
                <v-chip-group
                  v-model="categorias"
                  column
                  multiple
                  class="spaceEvenly"
                >
                  <v-chip
                    outlined
                    active-class="accent"
                    v-for="categoria in $store.state.categorias"
                    :key="categoria.id"
                    :value="categoria.id"
                    >{{ categoria.nome }}</v-chip
                  >
                </v-chip-group>

                <v-divider class="my-2" />

                <div style="display: flex; width: 100%; max-height: 28px">
                  <div style="font-size: 18px; display: block; float: left">
                    Faixa de valores
                  </div>

                  <v-switch
                    v-model="filtrarValores"
                    style="float: right; margin: 3px -8px 0px auto"
                  />
                </div>
                <div class="caption" style="float: left">
                  Selecione uma faixa de valores
                </div>

                <div
                  :style="
                    !filtrarValores
                      ? 'display: flex; width: 100%; pointer-events: none; opacity: 0.4'
                      : 'display: flex; width: 100%'
                  "
                >
                  <v-slider
                    class="ml-0"
                    style="border: 1px solid rgba(0, 0, 0, 0.12); border-radius: 16px; padding: 0px 8px; margin: 4px 4px 0px 0px"
                    track-color="grey"
                    always-dirty
                    min="0"
                    max="500"
                    hide-details
                    v-model="valorInicial"
                  />
                  <v-slider
                    class="mr-0"
                    style="border: 1px solid rgba(0, 0, 0, 0.12); border-radius: 16px; padding: 0px 8px; margin: 4px 0px 0px 4px"
                    track-color="grey"
                    always-dirty
                    min="0"
                    max="500"
                    hide-details
                    v-model="valorFinal"
                  />
                </div>
                <div
                  :style="
                    !filtrarValores
                      ? 'display: flex; align-items: center; pointer-events: none; opacity: 0.4'
                      : 'display: flex; align-items: center'
                  "
                >
                  <span class="caption" style="width: 50%; display: block"
                    >Valor Inicial</span
                  >
                  <span
                    class="h6 mr-1"
                    style="width: 100%; display: block; text-align: right"
                    >R$ {{ valorInicial | valorBR }}</span
                  >
                  <span class="caption ml-1" style="width: 50%; display: block"
                    >Valor Final</span
                  >
                  <span
                    class="h6"
                    style="width: 100%; display: block; text-align: right"
                    >R$ {{ valorFinal | valorBR }}</span
                  >
                </div>

                <v-divider class="my-2" />

                <!-- <div
                  style="font-size: 18px; width: 100%; display: block; padding-top: 4px"
                >Ordenar</div>
                <div class="caption">Selecione uma forma para ordenação dos produtos</div>
                <v-chip-group v-model="ordenacao" column class="spaceEvenly">
                  <v-chip
                    outlined
                    active-class="accent"
                    v-for="ordenacao in ordenacoes"
                    :key="ordenacao.id"
                    :value="ordenacao.id"
                  >{{ordenacao.nome}}</v-chip>
                </v-chip-group>

                <v-divider class="my-2" />-->

                <div v-if="user.tipo !== 'fornecedor'">
                  <div style="display: flex; width: 100%; max-height: 28px">
                    <div style="font-size: 18px; display: block">
                      Fornecedor
                    </div>
                  </div>
                  <div class="caption">Selecione um fornecedor</div>
                  <v-select
                    v-model="fornecedor"
                    placeholder="Todos"
                    ref="fornecedor"
                    :items="fornecedores"
                    item-text="nome_fantasia"
                    item-value="id"
                    dense
                    outlined
                    clearable
                    return-object
                    hide-details
                    rounded
                    class="mb-2 mt-1 paddindSelect"
                  />
                </div>

                <v-btn
                  depressed
                  class="ml-auto my-1 primary"
                  style="float: right"
                  @click="aplicarFiltro"
                  >Aplicar filtro</v-btn
                >
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </div>
      </v-col>
    </v-app-bar>

    <v-main style="background-color: whitesmoke">
      <v-slide-y-transition mode="out-in">
        <div style="height: calc(100% - 88px);">
          <v-container fluid pa-0 v-if="$route.name == 'loja'">
            <v-row
              :class="
                $vuetify.breakpoint.xsOnly ? 'ma-0 px-0 py-2' : 'mx-0 px-3 py-2'
              "
              style="justify-content: space-between; align-items: baseline;"
            >
              <v-col cols="12" sm="6" v-if="$vuetify.breakpoint.smAndUp">
                <div style="font-size: 24px; width: 100%" class="mx-0 mt-0">
                  {{
                    !($auth.user && $auth.user.tipo === "fornecedor")
                      ? "Novidades"
                      : "Meus Produtos"
                  }}
                </div>
              </v-col>
              <v-col cols="12" sm="4">
                <v-select
                  :items="ordenacoes"
                  item-text="nome"
                  item-value="id"
                  label="Ordenar por"
                  v-model="ordenacao"
                  hide-details
                  @change="aplicarFiltro"
                ></v-select>
              </v-col>
            </v-row>
          </v-container>

          <router-view />
        </div>
      </v-slide-y-transition>
    </v-main>

    <login
      :cadastroCliente="cadastroCliente"
      ref="login"
      :onLoginOk="loginOk"
      :email="user.email"
    />

    <pesquisa ref="pesquisaDialogo" />

    <filtro
      ref="filtroDialogo"
      :parametros="{
        categorias,
        filtrarValores,
        valorInicial,
        valorFinal,
        fornecedores,
      }"
      @onAplicarFiltro="aplicarFiltroMobile"
    />

    <v-dialog v-model="overlay" fullscreen>
      <v-container
        fluid
        fill-height
        style="background-color: rgba(0, 0, 0, 0.8);"
      >
        <v-layout justify-center align-center>
          <div
            style="background-color: white; border-radius: 50%; width: 180px; height: 180px; display: flex; align-items: center; justify-content: center"
          >
            <img
              src="@/assets/logo.svg"
              class="ml-2"
              style="max-height: 128px"
            />
          </div>
        </v-layout>
      </v-container>
    </v-dialog>

    <v-snackbar
      :timeout="snackbar.timeout"
      :color="snackbar.cor"
      center
      v-model="snackbar.exibir"
      @input="snackbar.cb"
      multi-line
    >
      <span v-html="snackbar.mensagem"></span>

      <template v-slot:action="{ attrs }">
        <v-btn icon text @click.native="snackbar.exibir = false" v-bind="attrs">
          <v-icon>close</v-icon>
        </v-btn>
      </template>
    </v-snackbar>

    <v-navigation-drawer
      v-if="
        user.tipo === !logado ||
          'cliente' ||
          user.tipo == 'representante' ||
          user.tipo == 'fornecedor'
      "
      v-model="drawerShop"
      absolute
      temporary
      right
      style="position:fixed; top:0; right:0; overflow-y:hidden;"
      :width="$vuetify.breakpoint.smAndUp ? '40vh' : '280px'"
    >
      <carrinho
        :update="drawerShop"
        :fecharDrawer="() => (this.drawerShop = false)"
        @abrirLoginCarrinho="loginCarrinho"
      />
    </v-navigation-drawer>

    <rodada-virtual v-if="$store.state.rodadaVirtualStatus" />

    <div
      v-if="showDevelopment"
      style="color: white; font-size: 24px; position: fixed; bottom: 10px; left: 10px; z-index: 1000; font-weight: 700; opacity: 0.5; border-radius: 4px; background-color: red; padding: 0px 18px; pointer-events: none;"
    >
      Development
    </div>

    <v-snackbar
      top
      center
      multi-line
      color="primary"
      :value="showUpdateMessage"
      timeout="-1"
    >
      Há uma nova atualização disponível!
      <template v-slot:action>
        <v-btn text @click="updateSoftware">
          Atualizar
        </v-btn>
      </template>
    </v-snackbar>

    <CaptureImage
      ref="changeLogo"
      title="Alterar Logo"
      @imagemCapturada="capturarLogo"
    />

    <v-dialog
      v-model="$store.state.showImprimirPdf"
      persistent
      overlay-opacity="0.9"
      style="margin: 12px !important"
    >
      <v-card class="pa-0" height="90vh">
        <v-app-bar color="primary" flat dark dense>
          <v-toolbar-title>Visualização de Impressão</v-toolbar-title>
          <v-spacer />
          <v-btn
            v-if="$store.state.pdfUrl"
            color="primary lighten-4 ml-4"
            @click="abrirPdfPagina"
          >
            Abrir em nova Página
          </v-btn>
          <v-btn color="primary lighten-4 ml-4" @click="hideImprimirPdf">
            Fechar
          </v-btn>
        </v-app-bar>
        <object
          type="application/pdf"
          :data="$store.state.pdfUrl || $store.state.pdfLoading"
          width="100%"
          height="100%"
        />
      </v-card>
    </v-dialog>
  </v-app>
</template>

<script>
import config from "@/config";
import cookie from "@/util/cookies.js";
import Login from "@/views/login/Login.vue";
import NotificacoesService from "../../services/notificacoes.js";
import menus from "@/views/menus";
import Carrinho from "@/views/loja/Carrinho.vue";
import Pesquisa from "@/views/loja/Pesquisa.vue";
import Filtro from "@/views/loja/Filtro.vue";
import ServicesUsers from "@/services/users.js";
import moment from "moment";
import * as temas from "@/plugins/temas";
import FornecedoresService from "../../services/fornecedores.js";
import RodadaVirtual from "../virtual/RodadaVirtual.vue";
import eventbus from "@/util/eventbus";

import CaptureImage from "@/components/CaptureImage";

// import io from "socket.io-client";

export default {
  name: "lojaPrincipal",
  components: {
    Login,
    Carrinho,
    Pesquisa,
    Filtro,
    RodadaVirtual,
    CaptureImage,
  },
  data: () => ({
    drawer: null,
    drawerShop: null,
    logado: false,
    overlay: true,
    cadastroCliente: true,
    user: {},

    notificacoes: 0,
    produtos_vencidos: [],

    dialog: false,
    tema: "padrao",
    impressao_remota: false,
    user_avatar: "img/briefcase.svg",
    snackbar: {
      exibir: false,
      mensagem: "",
      cor: "default",
      timeout: 3000,
      cb: null,
    },

    expansionPanel: [],
    categorias: [],
    filtrarValores: false,
    valorInicial: 0,
    valorFinal: 0,
    fornecedores: [],
    fornecedor: null,

    filtro: {
      termoPesquisa: "",
      categorias: [],
      filtrarValores: false,
      valorInicial: 0,
      valorFinal: 0,
      fornecedor: null,
      ordenacao: 0,
    },

    menu: false,
    ordenacao: 1,
    ordenacoes: [
      {
        id: 1,
        nome: "Mais Novos",
      },
      {
        id: 2,
        nome: "Mais Vendidos",
      },
      {
        id: 3,
        nome: "Maior Preço",
      },
      {
        id: 4,
        nome: "Menor Preço",
      },
    ],
    intervalo: null,
    showUpdateMessage: false,
    socket: null,
    porta_socket: 5000,
  }),

  created() {
    // Checar se está logado
    if (this.$auth.check()) {
      this.loginOk();
    } else {
      this.logout();
    }
  },

  mounted() {
    eventbus.$on("UPDATE_SOFTWARE", this.updateAvailable);

    // Eventos Notificação
    this.adicionarEventosDeNotificacao();

    if (this.$auth.check()) {
      // Ilha Impressão
      this.checkIlhaImpressao();
    }

    this.overlay = false;

    if (this.$route.query.login) {
      this.user.email = this.$route.query.login;
      this.login();
    }

    this.carregarFornecedores();

    if (this.$auth.check()) {
      this.countNotificacoes();
      clearInterval(this.intervalo);
      this.intervalo = setInterval(this.countNotificacoes, 120000);
    }

    this.$store.dispatch("sincronizar");

    let rodadaStorage = JSON.parse(localStorage.getItem("rodada"));
    if (rodadaStorage) {
      this.$store.commit("setFlagRodada", true);
    } else {
      this.$store.commit("setFlagRodada", false);
    }
  },

  beforeDestroy() {
    // Remover Eventos Notificação
    this.removerEventosDeNotificacao();
  },

  methods: {
    abrirPdfPagina() {
      window.open(this.$store.state.pdfUrl, "_blank");
      this.$store.commit("showImprimirPdf", false);
    },

    hideImprimirPdf() {
      this.$store.commit("showImprimirPdf", false);
    },

    connectSocket(host) {
      // this.socket = io(host);
    },

    startListening() {
      // this.socket.on("novaimpressao", (retorno_socket) => {
      //   if (retorno_socket.user_id == this.user.id) {
      //     this.$eventbus.notificar(
      //       "Sua impressão está pronta! Dirija-se à ilha de impressão para pegá-la"
      //     );
      //     this.$store.commit("setNovaImpressao", retorno_socket);
      //   }
      // });
    },

    updateSoftware() {
      this.showUpdateMessage = false;

      if (!this.registration || !this.registration.waiting) return false;

      this.registration.waiting.postMessage({ type: "SKIP_WAITING" });
      setTimeout(() => {
        window.location.reload(true);
      }, 1000);
    },
    updateAvailable(event) {
      this.registration = event.detail;
      this.showUpdateMessage = true;
    },
    async carregarFornecedores() {
      try {
        let fornecedores_response = await FornecedoresService.listarFiltroLoja();
        this.fornecedores = fornecedores_response.data.fornecedores;
      } catch (error) {
        console.log(error);
        this.$eventbus.erro(error.response.data.msg);
      }
    },
    reloadPage() {
      window.location.reload();
    },

    fecharPainel(event) {
      const { target } = event;
      if (target?.parentElement?.className?.substring?.(0, 6) !== "v-list") {
        if (typeof this.expansionPanel === "number") {
          this.categorias = [...this.filtro.categorias];
          this.filtrarValores = this.filtro.filtrarValores;
          this.valorInicial = this.filtro.valorInicial;
          this.valorFinal = this.filtro.valorFinal;
          this.fornecedor = this.filtro.fornecedor;
          this.ordenacao = this.filtro.ordenacao;
        }
        this.expansionPanel = [];
      }
    },

    aplicarFiltro() {
      this.filtro.categorias = [...this.categorias];
      this.filtro.filtrarValores = this.filtrarValores;
      this.filtro.valorInicial = this.valorInicial;
      this.filtro.valorFinal = this.valorFinal;
      this.filtro.fornecedor = this.fornecedor;
      this.filtro.ordenacao = this.ordenacao;
      this.$store.commit("setFiltro", { ...this.filtro });
      this.expansionPanel = [];
    },

    aplicarFiltroMobile(parametros) {
      this.filtro.categorias = [...parametros.categorias];
      this.filtro.filtrarValores = parametros.filtrarValores;
      this.filtro.valorInicial = parametros.valorInicial;
      this.filtro.valorFinal = parametros.valorFinal;
      this.filtro.fornecedor = parametros.fornecedor;
      this.filtro.ordenacao = this.ordenacao;
      this.$store.commit("setFiltro", { ...this.filtro });
    },

    abrirFiltro() {
      this.$refs.filtroDialogo.abrir();
    },

    loginCarrinho() {
      this.cadastroCliente = true;
      this.$refs.login.abrir();
    },

    login() {
      this.cadastroCliente = false;
      this.$refs.login.abrir();
    },

    loginOk() {
      if (this.$auth.check()) {
        this.logado = true;
        this.drawer = true;
        this.user = { ...this.$auth.user };
        this.$store.commit("setFiltro", {
          fornecedor: this.$auth.user.fornecedor_id || "",
        });
        this.setTema(this.$auth.user.tipo);
        this.setAvatar(this.$auth.user.tipo);
        this.overlay = false;

        this.connectSocket(`http://localhost:${this.porta_socket}`);
        this.startListening();
      }
    },

    logout() {
      this.$auth.logout();
      this.drawer = false;
      this.drawerShop = false;
      this.logado = false;
      this.user = {};

      // if (this.socket) {
      // this.socket.disconnect();
      // }

      clearInterval(this.intervalo);
      this.intervalo = null;

      this.setTema("padrao");
      localStorage.removeItem("rodada");
      this.$store.commit("zerarImpressoes");
      localStorage.setItem("impressao_remota", false);
      this.$store.commit("setRodada", {});
      this.$store.commit("setFiltro", {
        fornecedor: null,
      });

      const mapaStands = new URL(location.href).searchParams.get("mapa-stands");

      if (mapaStands) {
        location.href = `${location.origin}/#/mapa-stands/${mapaStands}`;
        return;
      }

      if (
        this.$router.currentRoute.name !== "loja" &&
        this.$route.name !== "mapa"
      ) {
        this.$router.push("/");
      }
    },

    setTema(tema) {
      if (tema === "padrao") {
        this.$vuetify.theme.themes.light = temas.TEMA_PADRAO;
      }
      if (tema === "fornecedor") {
        this.$vuetify.theme.themes.light = temas.TEMA_FORNECEDOR;
      }
      if (tema === "representante") {
        this.$vuetify.theme.themes.light = temas.TEMA_REPRESENTANTE;
      }
      if (tema === "cliente") {
        this.$vuetify.theme.themes.light = temas.TEMA_CLIENTE;
      }
      if (tema === "master") {
        this.$vuetify.theme.themes.light = temas.TEMA_MASTER;
      }
      if (tema === "administrador") {
        this.$vuetify.theme.themes.light = temas.TEMA_ADMINISTRADOR;
      }
    },

    setAvatar(tipo) {
      if (tipo === "fornecedor") {
        this.user_avatar = "img/shirt.svg";
      }
      if (tipo === "representante") {
        this.user_avatar = "img/briefcase.svg";
      }
      if (tipo === "cliente") {
        this.user_avatar = "img/online-shop.svg";
      }
      if (tipo === "master") {
        this.user_avatar = "img/master.svg";
      }
      if (tipo === "administrador") {
        this.user_avatar = "img/admin.svg";
      }
      // if (tipo === "fornecedor") {
      //   this.user_avatar = config.baseUrl + "./img/shirt.svg";
      // }
      // if (tipo === "representante") {
      //   this.user_avatar = config.baseUrl + "./img/briefcase.svg";
      // }
      // if (tipo === "cliente") {
      //   this.user_avatar = config.baseUrl + "./img/online-shop.svg";
      // }
      // if (tipo === "master") {
      //   this.user_avatar = config.baseUrl + "./img/master.svg";
      // }
      // if (tipo === "administrador") {
      //   this.user_avatar = config.baseUrl + "./img/admin.svg";
      // }
    },

    adicionarEventosDeNotificacao() {
      this.$eventbus.onNotificar((mensagem) => {
        this.snackbar = {
          exibir: true,
          mensagem: mensagem,
          cor: "primary",
          timeout: 5000,
        };
      });

      this.$eventbus.onErro((e) => {
        let erro = {
          codigo: "",
          mensagem: "",
        };

        if (typeof e.error != "undefined") {
          if (typeof e.error.response != "undefined") {
            (erro.codigo = e.error.response.status),
              // erro.mensagem = e.error.response.statusText
              (erro.mensagem = e.error.response.data.msg);

            if (erro.codigo == 401) {
              this.snackbar = {
                exibir: true,
                mensagem: "Sua sessão expirou... Efetue login novamente.",
                cor: "error",
                timeout: 5000,
                cb: () => {
                  this.$auth.logout();
                  this.$router.push("/");
                },
              };
              return;
            }
          } else {
            (erro.codigo = "100"), (erro.mensagem = e.error.message);
          }
        } else {
          (erro.codigo = "100"), (erro.mensagem = "");
        }

        this.snackbar = {
          exibir: true,
          // mensagem: `<b>${e.mensagem} </b><br> (${erro.codigo}) ${erro.mensagem}`,
          mensagem: `<b>${e.mensagem} </b>`,
          cor: "error",
          timeout: 10000,
          cb: null,
        };
      });
    },

    removerEventosDeNotificacao() {
      // Remove os eventos das mensagens de notificação e erro
      // NÃO REMOVER
      this.$eventbus.$off("EXIBIR_MENSAGEM");
      this.$eventbus.$off("EXIBIR_MENSAGEM_ERRO");
    },

    minhaConta() {
      var tipo = this.user.tipo;
      switch (tipo) {
        case "fornecedor":
          if (this.$router.history.current.path != "/fornecedor/minha-conta")
            this.$router.push("/fornecedor/minha-conta");
          break;
        case "cliente":
          if (this.$router.history.current.path != "/cliente/minha-conta")
            this.$router.push("/cliente/minha-conta");
          break;
        case "representante":
          if (this.$router.history.current.path != "/representante/minha-conta")
            this.$router.push("/representante/minha-conta");
          break;
        case "administrador":
          if (this.$router.history.current.path != "/administrador/minha-conta")
            this.$router.push("/administrador/minha-conta");
          break;
        case "master":
          if (this.$router.history.current.path != "/master/minha-conta")
            this.$router.push("/master/minha-conta");
          break;
      }
    },

    alterarLogo() {
      this.$router.push("/alterar-logo");
    },

    capturarLogo(new_logo) {
      this.$refs.changeLogo.fechar();
      //IMPLEMENTAR TELA PARA VISUALIZAR/ALTERAR A LOGO ATUAL
      // SALVAR LOGO NOVA NO BANCO
    },

    alterarSenha() {
      this.$router.push("/alterar-senha");
    },

    async countNotificacoes() {
      try {
        let response = await NotificacoesService.index();
        this.notificacoes = response.data.contagem;

        this.$store.commit("setCountNotificacoes", response.data.contagem);
      } catch (error) {
        console.log(error);
        this.$eventbus.erro("Erro ao carregar as notificações");
      }
    },

    pesquisarProdutos(key) {
      this.filtro.termoPesquisa = this.filtro.termoPesquisa.trimStart();
      if (key.code === "Enter") {
        this.$store.commit("setFiltro", {
          termoPesquisa: this.filtro.termoPesquisa,
        });
      }
    },

    pesquisarProdutosClick(key) {
      this.filtro.termoPesquisa = this.filtro.termoPesquisa.trimStart();
      this.$store.commit("setFiltro", {
        termoPesquisa: this.filtro.termoPesquisa,
      });
    },
    checkIlhaImpressao() {
      let impressao_storage = JSON.parse(
        localStorage.getItem("impressao_remota")
      );
      if (typeof impressao_storage === "boolean") {
        this.impressao_remota = impressao_storage;
      } else {
        this.impressao_remota = true;
      }
    },
  },

  computed: {
    mostrarIlhaDeImpressao() {
      let dataInicio = moment(
        this.$store.state.rodada.data_inicio,
        "DD/MM/YYYY"
      );
      let dataFim = moment(this.$store.state.rodada.data_fim, "DD/MM/YYYY");
      let hoje = moment();
      let diferencaInicio = hoje.diff(dataInicio, "days");
      let diferencaFim = hoje.diff(dataFim, "days");
      if (!isNaN(diferencaInicio) || !isNaN(diferencaFim)) {
        if (diferencaInicio < 0) {
          this.impressao_remota = false;
          localStorage.setItem("impressao_remota", false);
          return false;
        } else if (diferencaFim > 0) {
          this.impressao_remota = false;
          localStorage.setItem("impressao_remota", false);
          return false;
        } else {
          return true;
        }
      }
    },
    ordenacaoNome() {
      let ordenacao_selecionada = this.ordenacoes.filter((ordenacao) => {
        return ordenacao.id == this.ordenacao;
      });

      return ordenacao_selecionada[0].nome;
    },
    showDevelopment() {
      return (
        !["https://namoda.com.vc", "https://www.namoda.com.vc"].includes(
          window.location.origin
        ) && !window.localStorage.getItem("devOff")
      );
    },
  },

  watch: {
    impressao_remota: {
      handler: function(impressao_remota) {
        localStorage.setItem("impressao_remota", impressao_remota);
      },
    },

    valorInicial: function(value) {
      if (this.valorInicial > this.valorFinal) {
        this.valorFinal = this.valorInicial;
      }
    },

    valorFinal: function(value) {
      if (this.valorInicial > this.valorFinal) {
        this.valorInicial = this.valorFinal;
      }
    },

    "$store.state.filtro": {
      handler: function(filtro) {
        this.filtro.termoPesquisa = filtro.termoPesquisa;
        this.filtro.categorias = [...filtro.categorias];
        this.filtro.filtrarValores = filtro.filtrarValores;
        this.filtro.valorInicial = filtro.valorInicial;
        this.filtro.valorFinal = filtro.valorFinal;
        this.filtro.fornecedor = filtro.fornecedor;
        this.categorias = [...filtro.categorias];
        this.filtrarValores = filtro.filtrarValores;
        this.valorInicial = filtro.valorInicial;
        this.valorFinal = filtro.valorFinal;
      },
      deep: true,
    },
  },

  filters: {
    capitalize(s) {
      if (typeof s !== "string") {
        return "";
      }
      return s.charAt(0).toUpperCase() + s.slice(1);
    },
  },
};
</script>

<style>
.wrapContent > div {
  padding: 0px 12px 8px 12px !important;
  background-color: white;
}

.spaceEvenly > div > div {
  justify-content: space-between !important;
}

.paddindSelect > div > div {
  padding: 0px 12px !important;
}

.progressFiltro {
  background-color: white;
  border-radius: 50%;
  width: 96px;
  height: 96px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

html {
  scroll-behavior: smooth;
}

@media print {
  .no-print,
  .no-print * {
    display: none !important;
  }
}
</style>
